// extracted by mini-css-extract-plugin
module.exports = {"addPackageButton":"styles_addPackageButton__1pwwq"};